import { useStopStreamMutation } from "../../api/apiSlice";
import { IStream } from "api/apiTypes";

interface StreamProps {
  s: IStream;
}

export const Stream = (props: StreamProps) => {
  const s = props.s;
  const [stopStream] = useStopStreamMutation();

  const onStopClicked = async (streamId: string) => {
    stopStream(streamId);
  };

  return (
    <tr>
      <td>
        <p>{s.name}</p>
      </td>
      <td>
        <p>{s.videoId}</p>
      </td>
      <td>
        <p>{s.heartbeat}</p>
      </td>
      <td className="align-middle text-center">
        <button
          type="button"
          className="btn btn-danger bi bi-trash"
          onClick={() => onStopClicked(s.videoId)}
        >
          {" "}
          Stop{" "}
        </button>
      </td>
    </tr>
  );
};
